// @ts-nocheck
import { Fragment, FunctionComponent, h } from "preact";
import { useEffect, useMemo, useState } from "preact/hooks";
import { getAuthToken } from "../../../utils/storage/storage";
import { useLocation } from "react-router-dom";
import * as logic from "./logic";
import BaseMenu from "../base-menu";
import { Default, Mobile } from "../../../utils/query";
import SidebarMobile from "./mobile";
import SidebarDefault from "./default";
import { useSelector } from "react-redux";
import { IRouteElement } from "../../../routes/interface";

export interface ISidebar {
  listMenu?: FunctionComponent;
  selectedMenu?: string[];
  setSelectedMenu?: any;
  collapsed: boolean;
  onCollapse: (c: boolean) => any;
}

const Sidebar = ({ collapsed, onCollapse }: ISidebar) => {
  const menu = useSelector((state: IAuthState) => state.menu.menu);
  const isLogined = getAuthToken();
  const { pathname } = useLocation();
  const [selectedMenu, setSelectedMenu] = useState([]);
  const changeDeviceCount = useSelector(
    (state: any) => state.change.change?.length
  );

  useEffect(() => {
    const find = menu.find((e: IRouteElement) => e.PATH === pathname);
    if (find) {
      setSelectedMenu([find.KEY]);
    }
  }, [pathname]);

  const listMenu = useMemo(() => {
    return menu.map((e: IRouteElement) =>
      BaseMenu({ item: e, selectedMenu, setSelectedMenu })
    );
  }, [selectedMenu, changeDeviceCount]);

  if (!isLogined) {
    return <div />;
  }

  if (!logic.matchUrlMenuSidebar(pathname)) {
    return <div />;
  }

  return (
    <>
      <Default>
        <SidebarDefault
          listMenu={listMenu}
          collapsed={collapsed}
          onCollapse={onCollapse}
          selectedMenu={selectedMenu}
        />
      </Default>
      <Mobile>
        <SidebarMobile
          listMenu={listMenu}
          collapsed={collapsed}
          onCollapse={onCollapse}
          selectedMenu={selectedMenu}
        />
      </Mobile>
    </>
  );
};

Sidebar.propTypes = {};

export default Sidebar;
